import { Button } from 'primereact/button'
import { MultiSelectPanelHeaderTemplateParams } from 'primereact/multiselect'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { MultiSelectWrapper, StyledMultiSelect } from 'components/map/styled'
import DatePickerIcon from 'components/ui/DatePickerIcon'
import styled from 'styled-components'
import { IEmployeeSummary } from 'types/Employee'
import AuthUtil from 'utils/AuthUtil'
import { ReservationStatus } from '../../types/RemoteReservationRequest'

interface ITracingSearchProps {
  endDate: Date
  setEndDate: Dispatch<SetStateAction<Date | Date[] | undefined>>
  startDate: Date
  setStartDate: Dispatch<SetStateAction<Date | Date[] | undefined>>
  selectedStatus: ReservationStatus[]
  setSelectedStatus: Dispatch<SetStateAction<ReservationStatus[]>>
  getTableList: () => void
}

export default function NotificationFilterForm(props: ITracingSearchProps) {
  const { endDate, setEndDate, startDate, setStartDate, selectedStatus, setSelectedStatus, getTableList } = props

  const { t } = useTranslation()

  const employee = AuthUtil.getEmployeeSummary() as IEmployeeSummary

  const reservationStatuses = [
    { value: 1, label: t('request-remote-reservation.pending-approval') },
    { value: 2, label: t('request-remote-reservation.approved') },
    { value: 3, label: t('request-remote-reservation.rejected') },
  ]

  const onClickLocation = () => {
    var button = document.getElementsByClassName('p-button p-component p-autocomplete-dropdown p-button-icon-only')
    if (button !== undefined && button.length > 0) {
      // @ts-ignore
      button[0].click()
    }
  }

  const initSearchButtonDisable = () => {
    var dropdownButton = document.getElementsByClassName(
      'p-button p-component p-autocomplete-dropdown p-button-icon-only'
    )
    if (dropdownButton !== undefined && dropdownButton.length > 0) {
      dropdownButton[0].classList.add('d-none')
    }
  }

  useEffect(() => {
    initSearchButtonDisable()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  /* Templates (choose all) */
  function panelHeaderTemplate(options: MultiSelectPanelHeaderTemplateParams) {
    return (
      <div className="p-multiselect-header">
        <label className="d-flex align-items-center">
          {options.checkboxElement}
          <span role="button" className="px-2 user-select-none">
            {t('buttons.choose-all')}
          </span>
        </label>
        {options.closeElement}
      </div>
    )
  }

  return (
    <div className="tracing-search">
      <StyledDiv className="reservationStatus">
        <MultiSelectWrapper>
          <label className="autocomplete-title">{t('input-texts.choose-status')}</label>
          <StyledMultiSelect
            id="reservationStatusType"
            name="resType"
            selectedItemsLabel={t('most-used-words.all-selected')}
            filter={false}
            scrollHeight="145px"
            maxSelectedLabels={3}
            optionLabel="label"
            optionValue="value"
            panelHeaderTemplate={panelHeaderTemplate}
            options={reservationStatuses}
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.value)}
            placeholder={t('input-texts.choose-status-placeholder')}
          />
        </MultiSelectWrapper>
      </StyledDiv>

      <StyledDiv className="campusDate">
        <DatePickerIcon
          showOtherMonths
          selectOtherMonths
          disabledDays={[]}
          idName={'campus-tracing-start-date'}
          defaultDate={startDate}
          maxDate={endDate}
          showButtonBar
          onSelectedDateChange={(e) => setStartDate(e.value ?? undefined)}
          label={t('input-texts.start-date')}
          placeholder={t('input-texts.select-date')}
        />
      </StyledDiv>

      <StyledDiv className="campusDate">
        <DatePickerIcon
          showOtherMonths
          selectOtherMonths
          disabledDays={[]}
          idName={'campus-tracing-end-date'}
          defaultDate={endDate}
          minDate={startDate}
          showButtonBar
          onSelectedDateChange={(e) => setEndDate(e.value ?? undefined)}
          label={t('input-texts.end-date')}
          placeholder={t('input-texts.select-date')}
        />
      </StyledDiv>

      <Button
        style={{ minWidth: '100px', maxWidth: '180px' }}
        className="search-button"
        label={t('buttons.update-list')}
        onClick={getTableList}
      />
    </div>
  )
}

const StyledDiv = styled.div`
  &.campusService {
    width: 280px;
    max-width: 300px;
    @media (max-width: 1200px) {
      min-width: 185px;
      max-width: 200px;
    }
  }

  &.campusDate {
    min-width: 145px;
    max-width: 250px;

    @media (max-width: 1200px) {
      width: 240px;
      max-width: 135px;
    }
  }
  &.reservationStatus {
    width: 30%;
  }
`
